import {BuildGameConfigurations, ModeSettingEnum} from '@colonist/game-base-types'
import {UIAdController} from '../../../shared/scripts/ui_ad/UIAdController'
import {UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager'
import {UIMGameToolTipController} from './ui_game_tooltip/UIMGameToolTipController'
import {UIMGameCanvasController} from './UIMGameCanvasController'
import {UIGameActionsController} from '../../../shared/scripts/ui_game/ui_game_actions/UIGameActionsController'
import {UIGameCardController} from '../../../shared/scripts/ui_game/ui_game_card/UIGameCardController'
import {UIMGameMapController} from './ui_game_map/UIMGameMapController'
import {UIGameTurnSoundController} from '../../../shared/scripts/ui_game/UIGameTurnSoundController'
import {UIMGamePopupController} from './ui_game_popup/UIMGamePopupController'
import {UIGameGoldTileController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameGoldTileController'
import {UIGameController} from '../../../shared/scripts/ui_game/UIGameController'
import {GameState, NestedReadonly} from '@colonist/game-states'
import {UIReplayController} from '../../../shared/scripts/ui_replay/UIReplayController'
import {UIGamePauseController} from '../../../shared/scripts/ui_game/UIGamePauseController'
import {UIGameAchievementController} from '../../../shared/scripts/ui_game/ui_game_achievement/UIGameAchievementController'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'

export class UIMGameManager extends UIGameManager {
    constructor(adController: UIAdController) {
        super(adController)

        const body = document.getElementsByTagName('body')[0]
        body.classList.add('m-new-game')

        this.canvasController = new UIMGameCanvasController(this)
        this.toolTipController = new UIMGameToolTipController(this)
    }

    buildGame(configurations: BuildGameConfigurations) {
        this.canvasController.responsiveController.resizeScreen()
        this.gameController = new UIGameController(this, configurations)

        super.buildGame(configurations)

        const {
            mechanicSettlementState,
            mechanicCityState,
            mechanicRoadState,
            mechanicRobberState,
        } = configurations.gameState

        this.mapController = new UIMGameMapController(this) // Jan 28, 2021. Jeff: Map first so its below containers
        this.actionsController = new UIGameActionsController(this, mechanicSettlementState, mechanicCityState, mechanicRoadState)
        this.cardController = new UIGameCardController(this, mechanicRobberState)
        new UIGameAchievementController(this)
        new UIGameTurnSoundController(this)
        new UIMGamePopupController(this)
        this.pauseController = new UIGamePauseController(this)
        new UIGameGoldTileController(this)

        this.buildOrderDependentControllers(configurations.gameState)

        const isColonistRush = this.gameController.gameSettings.modeSetting == ModeSettingEnum.ColonistRush4P
        if(isColonistRush) this.addColonistRushBranding()
    }

    buildReplayView(replayController: UIReplayController): void {
        this.canvasController.removeResizeListener()
    }

    private buildOrderDependentControllers(gameState: NestedReadonly<GameState>) {
        this.mapController.createMap()
        this.buildOptionalMechanics(gameState)
        this.mapController.mapView.sortChildren()
        if(this.originalMapPosition != undefined) {
            this.mapController.mapView.scale.set(this.originalMapPosition.zoom.x, this.originalMapPosition.zoom.y)
            this.mapController.mapView.emit('zoomed', this.mapController.mapView.DEFAULT_ZOOM_EVENT)
            this.mapController.mapView.repositionMap(this.originalMapPosition.location)
        }
    }

    // eslint-disable-next-line class-methods-use-this
    openShareLinkMobileModal(link: string) {
        const url = new URL(link)
        UIMDeviceHandler.sendShareLink(url.href)
    }
}
